import {useEffect,useRef,useState,type RefObject} from 'react';
import type {PlayerRef} from '@remotion/player';

const SOURCE_PREVIEW='waka-work-source-preview';
/** Source audition is independent of timeline edits and stops when its card is removed. */
export function WorkMediaPreview({type,url,name,playerRef}:{type:'audio'|'video';url:string;name:string;playerRef:RefObject<PlayerRef|null>}){
  const media=useRef<HTMLMediaElement|null>(null);
  const [playing,setPlaying]=useState(false);
  const [failed,setFailed]=useState(false);
  useEffect(()=>{
    const stop=()=>media.current?.pause();
    const another=(event:Event)=>{if((event as CustomEvent).detail!==media.current)stop();};
    const player=playerRef.current;
    window.addEventListener(SOURCE_PREVIEW,another);
    player?.addEventListener('play',stop);
    const element=media.current;
    return ()=>{element?.pause();window.removeEventListener(SOURCE_PREVIEW,another);player?.removeEventListener('play',stop);};
  },[url,playerRef]);
  const play=()=>{
    setPlaying(true);setFailed(false);
    playerRef.current?.pause();
    window.dispatchEvent(new CustomEvent(SOURCE_PREVIEW,{detail:media.current}));
  };
  const common={src:url,controls:true,preload:'none' as const,onPlay:play,onPause:()=>setPlaying(false),onEnded:()=>setPlaying(false),onError:()=>setFailed(true),draggable:false,
    onDragStart:(event:React.DragEvent)=>event.stopPropagation(),
    'aria-label':`${name} 원본 미리보기`,className:'h-20 w-full min-w-0 object-contain'};
  const toggle=()=>{
    const element=media.current;if(!element)return;
    if(element.paused)void element.play().catch(()=>{setFailed(true);setPlaying(false);});
    else element.pause();
  };
  return <div className="space-y-1">
    {type==='video'?<video {...common} ref={element=>{media.current=element;}} playsInline/>:<audio {...common} ref={element=>{media.current=element;}}/>}
    <button type="button" onClick={toggle} aria-label={`${name} 원본 ${playing?'일시정지':'재생'}`} className="w-full rounded border border-neutral-600 p-1 text-xs">{playing?'일시정지':'원본 재생'}</button>
    {failed&&<p role="status" className="text-xs">원본을 재생하지 못했습니다. 주소나 파일을 확인해 주세요.</p>}
  </div>;
}
